import { render } from "./PrintersList.vue?vue&type=template&id=74717163"
import script from "./PrintersList.vue?vue&type=script&lang=js"
export * from "./PrintersList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__